export const getName = (id, list) => {
    return (list || []).find(element => element?._id === id)?.name || '';
}
export const getData = (id, list) => {
    let data = list.filter(element =>element._id === id)[0] ;
    return { value: data._id, label: data.name };
}
